import types from './types';

/**
 * Set menu object in redux that will be edited
 * @param {Object} menu
 */
const setMenuToEdit = menu => ({
  type: types.SET_MENU_TO_EDIT,
  menu
});

/**
 * Remove menu object that will be edited from redux
 */
const resetMenuToEdit = () => ({
  type: types.RESET_MENU_TO_EDIT
});

/**
 * Make request to edit a menu
 */
const editMenuRequest = editedMenu => ({
  type: types.EDIT_MENU_REQUEST,
  editedMenu
});

/**
 * Successful menu edit
 */
const editMenuSuccess = () => ({
  type: types.EDIT_MENU_SUCCESS
});

/**
 * Unsuccessful menu edit
 * @param {Error} error
 */
const editMenuFailure = error => ({
  type: types.EDIT_MENU_FAILURE,
  error
});

export default {
  setMenuToEdit,
  resetMenuToEdit,
  editMenuRequest,
  editMenuSuccess,
  editMenuFailure
};
